<template>
   <el-form ref="Synthesis" class="yk-synthesis" label-width="90px" label-position="left">
    <el-row style="border-bottom: 1px solid silver;">
      <el-col :span="22" :offset="1">
        <el-form-item label="题干：">
          <span class="yk-synthesis-question" v-html="data.Content"></span>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row v-if="filesList.length > 0">
      <el-col :span="22" :offset="1">
        <el-form-item label="题目附件：">
            <QuestionFile ref="fileList" :url="urlAliyunOSS" :fileIds.sync="fileIds" :filesList="filesList" :files.sync="fileList" :IsUpload="false"/>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row v-for="(item,index) in childQuestionList" :key="index+1" style="border-bottom: 1px solid silver;">
      <el-col :span="22" :offset="1">
        <el-form-item :label="'题目'+(index+1)+'：'">
          <span class="yk-synthesis-question" v-html="item.questionTitle"></span>
        </el-form-item>
        <el-form-item label="选项：" v-if="item.QuestionType == 1 || item.QuestionType == 2">
          <el-form-item v-for="(li,index1) in item.radioData" :key="li">
            <span>{{selects[index1]}}、{{li}}</span>
          </el-form-item>
        </el-form-item>
        <el-form-item label="答案：" v-if="item.QuestionType == 1 || item.QuestionType == 2">
          <span v-for="(CheckValue,index2) in item.radio" :key="index2" v-if="item.radio.length > index2">{{selects[CheckValue]}}；</span>
          <span v-for="(CheckValue,index2) in item.radio" :key="index2" v-else>{{selects[CheckValue]}}</span>
        </el-form-item>
        <el-form-item label="答案：" v-else-if="item.QuestionType == 3">
          <span v-if="item.radio[0] == 1">对</span>
          <span v-else-if="item.radio[0] == 0">错</span>
        </el-form-item>
        <el-form-item label="解析：">
          <span class="yk-synthesis-question" v-html="item.analysisContent" v-if="item.analysisContent"></span>
          <span class="yk-synthesis-question" v-else>无</span>
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
import QuestionFile from 'components/AliyunOSS/QuestionBankFile.vue';

export default {
  name: 'choice',
  components: {
    QuestionFile
  },
  props: {
    data: {
      type: Object,
      default: null
    },
    childQuestionList: {
      default: []
    }
  },
  created() {
    this.filesList = this.data.stemFiles;
  },
  data() {
    return {
      urlAliyunOSS: '/api/design/osssign/getsign',
      // 题干附件
      fileList: [],
      fileIds: [], // 附件Id
      filesList: [],
      selects: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V']
    };
  },
  methods: {
  }
};
</script>

<style lang="scss">

.yk-synthesis {
  .yk-synthesis-question{
    p{
      margin:0;
      padding:0;
    }
  }
}
</style>

